// extracted by mini-css-extract-plugin
module.exports = {"content":"ArticleHero_content__bhgYe","date":"ArticleHero_date__TFk2L"};